import {Field} from 'formik';

import {
    FormikSelect,
    FormikTextInput,
    PlatformFieldset,
} from '@flexinet/ui-components';
import {
    Alert,
    Stack,
} from '@mantine/core';
import {AiOutlineInfoCircle} from 'react-icons/ai';

import {ActionStatus} from '../types.ts';
import {ApplicationField} from '../../testing-api-integration/components/ApplicationField.tsx';
import {ActionCodeField} from '../../testing-api-integration/components/ActionCodeField.tsx';

const STATUS_OPTIONS = [
    {
        label: 'Draft',
        value: ActionStatus.DRAFT,
    },
    {
        label: 'Active',
        value: ActionStatus.ACTIVE,
    },
    {
        label: 'Retired',
        value: ActionStatus.RETIRED,
    },
];

export const FormComponent = ({editing = false}: { editing?: boolean }) => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Action Details'}>

                {/* FNP-995: was a required free-text box. The actionCode is the
                    name the code gave itself, so the console offers the handlers
                    this deployment can actually perform instead of asking a human
                    to type a machine-owned identifier. Still an Autocomplete, not
                    a Select — an unregistered code stays legal (FNP-859). */}
                <ActionCodeField />

                <Field
                    name='name'
                    label='Name'
                    description='Human-friendly name shown in the catalog'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                {/* FNP-979: a real foreign key into the console application
                    catalog, not a hand-typed label. Optional by design — see
                    ApplicationField. On an Action this is a catalog facet only;
                    the executor never reads it. */}
                <ApplicationField
                    description='The application this action exercises. Used to group and filter the catalog.'
                />

                {editing ? (
                    <Alert
                        icon={<AiOutlineInfoCircle/>}
                        color='blue'
                        my={'xl'}
                        title='Status is changed separately'
                    >
                        Use the Activate / Retire buttons on the action page. Status
                        transitions are validated by the server, so they are not part
                        of this form.
                    </Alert>
                ) : (
                    <Field
                        name='status'
                        label='Status'
                        description='Required. Only ACTIVE actions are offered when composing a persona.'
                        component={FormikSelect}
                        data={STATUS_OPTIONS}
                        withAsterisk
                        my={'xl'}
                    />
                )}

            </PlatformFieldset>
        </Stack>
    );
};
